import { ref } from "vue";
  import * as utils from "@/utils/index";
  export default () => {
    const languageList = ["zh-TW"];
    const pageInfo = {"default":{"title":"","ico":"https://cdnimages.awselbcombine.com/public_images/one_image/2023/06/168716003084524221.png"},"zh-TW":{"title":"中秋贈豪禮","ico":"https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1726307208104-40.png"}};

    const languageTxt = {"zh-TW":{"myPackage":"我的獎勵","logout":"登出帳號","pleaseLogin":"请先登入帳號","unBind":"未綁定","infoBtn":"活動規則","mySignTime":"當前累計簽到","myCoupon":"我的抽獎券","refresh":"刷新","myLotteryTime":"累計消耗抽獎券數量","day":"天","myNextCoupon1":"距離下一張抽獎券只需 $d","bindTitle":"綁定角色","selectServer":"請選擇伺服器","selectRole":"請選擇角色","packageTime":"領取時間","packageName":"獎勵","successTitle":"恭喜獲得","quanInfo":"抵扣券已放入個人錢包","gotoSee":"查看","-10001":"參數錯誤","-10002":"您尚未達到領獎條件","-10003":"發獎失敗","-10007":"您已經綁定過了","-20015":"角色不存在","-20001":"您已領取過該禮包～不可貪心哦～","-60001":"抽獎券數量不足","-60002":"抽獎失敗：沒有獎勵可抽","-1005":"活動還沒開始，請耐心等待","-1006":"活動已結束，謝謝參與","-1001":"餵餵，夠了啊，這是開加速了麼，這走馬燈是腫麼回事啊，ΣO口O~不如稍作休息吧","todayPayFinish":"恭喜您已獲得今日所有的抽獎券，請明日再來～","common":"系統繁忙，請稍後再試","-10010":"您的簽到天數不足，無法領取當前獎勵","-10011":"已經領取該獎勵","-10012":"您尚未完成儲值，無法領取獎勵","-10013":"累計消耗抽獎券數量不足，無法領取","login":"登入帳號","getBtn":"領取","sureBtn":"確認","bindBtn":"立即綁定","useBtn":"立即使用","hasBtn":"已領取","gotoStoreBtn":"立即儲值","lotteryBtn":"立即抽獎","exchangeUse":"消耗","checkGiftBtn":"查看獎勵","copySucc":"複製成功","copy":"複製","gotoExchange":"前往兌換","giftCode":"兌換碼","copyAndGoExchange":"複製並前往兌換","inLottery":"正在抽取獎勵⋯⋯","lottery10":"十次抽獎","lottery10error":"共成功抽取 {{n}} 次，已為您退回抽獎失敗的次數","changRole":"切換角色","yourServer":"您的伺服器","allServer":"全部伺服器","fwtk":"服務條款","yszc":"隱私政策","zzf":"","sqf":"","emptyBag":"","daojuTips":"獎勵已發放至綁定角色內，請注意查收","canNoReBind":"","goPay":"立即儲值","downloadGame":"下載遊戲"},"default":{"myPackage":"","logout":"","pleaseLogin":"","unBind":"","infoBtn":"","mySignTime":"","myCoupon":"","refresh":"","myLotteryTime":"","day":"","myNextCoupon1":"","bindTitle":"","selectServer":"","selectRole":"","packageTime":"","packageName":"","successTitle":"","quanInfo":"","gotoSee":"","-10001":"","-10002":"","-10003":"","-10007":"","-20015":"","-20001":"","-60001":"","-60002":"","-1005":"","-1006":"","-1001":"","todayPayFinish":"","common":"","-10010":"","-10011":"","-10012":"","-10013":"","login":"","getBtn":"","sureBtn":"","bindBtn":"","useBtn":"","hasBtn":"","gotoStoreBtn":"","lotteryBtn":"","exchangeUse":"","checkGiftBtn":"","copySucc":"","copy":"","gotoExchange":"","giftCode":"","copyAndGoExchange":"","inLottery":"","lottery10":"","lottery10error":"","changRole":"","yourServer":"","allServer":"","fwtk":"","yszc":"","zzf":"","sqf":"","emptyBag":"","daojuTips":"","canNoReBind":"","goPay":"","downloadGame":""}};
  
    const getSystemLanguage =  ()=>{
      let res = navigator.language || navigator.userLanguage || navigator.browerLanguage || navigator.systemLanguage;
      if (res.indexOf("-") > -1) {
        const langArr = res.split("-");
        res = langArr[0] === "zh" ? langArr[1] : langArr[0];
      }
      return res.toLowerCase();
    };
    const checkLanguage =  (lang) =>{
      let res = "";
      if (lang) {
        if (lang.indexOf("-") > -1) {
          for (let i = 0; i < languageList.length; i++) {
            if (languageList[i] === lang) {
              res = languageList[i];
            }
          }
        } else {
          const reg = new RegExp(lang, "g");
          for (let i = 0; i < languageList.length; i++) {
            if (reg.test(languageList[i].toLowerCase())) {
              res = languageList[i];
            }
          }
        }
      }
      return res;
    };
    let curLang = checkLanguage(utils.getUrlParams("appLanguage")) || checkLanguage(utils.getUrlParams("language")) || checkLanguage(getSystemLanguage()) || checkLanguage("zh-TW") || "default";
    const initLang = () => {
      document.body.className += " " + curLang;
      document.getElementsByTagName("html")[0].setAttribute("dir", curLang == "ar-SA" ? "rtl" : "ltr");
      
      if(!pageInfo[curLang]) return;
      if(pageInfo[curLang].title){
        document.title = pageInfo[curLang].title;
      }
      if(pageInfo[curLang].ico){
        try{
          document.getElementById("icon").setAttribute("href", pageInfo[curLang].ico);
          document.getElementById("shortcut").setAttribute("href", pageInfo[curLang].ico);
        }catch(e){}
      }
    };

    const getLangTxt = (key,msg)=>{
      let info = languageTxt[curLang] || languageTxt.default;
      return info[key] || String(msg);
    }
  
    return { curLang, initLang, getLangTxt, langData:languageTxt[curLang]||{} };
  };
  